export function getPreviewUrl(assetId: string = ''): string {
  if (!assetId) return '';

  return `/api/asset/${assetId}`;
}
